import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View, Text, StyleSheet } from 'react-native';
import QRCode from 'react-native-qrcode-svg';

class QrCode extends Component {
  static propTypes = {
    translation: PropTypes.objectOf(PropTypes.any).isRequired,
    code: PropTypes.string.isRequired,
  };

  render() {
    const { translation, code } = this.props;
    const labels = {
      qr_code: translation.your_qr_code,
    };

    return (
      <View style={styles.container}>
        <Text style={styles.text}>{labels.qr_code}</Text>
        <View style={styles.qrContainer}>
          <QRCode value={code} size={178} />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  text: {
    fontSize: 16,
    textAlign: 'center',
  },
  qrContainer: {
    marginTop: 22,
    marginBottom: 15,
    flexDirection: 'row',
    justifyContent: 'center',
  },
});

export default QrCode;
